import React , {useState}    from 'react';
import ReactDOM from 'react-dom';
import {SectionsContainer, Section, Header,Footer } from 'react-fullpage';
import Home from './Home/Home';
import About from './About/About';
import Education from './Education/Education';
import Works from './Works/Works';
import Projects from './Projects/Projects';
import Contact from './Contact/Contact';
import './App.css';
import Sidebar from './Navigation/Sidebar/Sidebar';
import DarkModeToggle from './Dark/DarkModeToggle';
import './Dark/styles.scss';


const Mstyle= {
  color : "blue",
  fontSize: "65px",
};

export default class extends React.Component {
  
  render() {
    let options = {
      sectionClassName:     'section',
      anchors:              ['Home', 'About', 'Education', 'Works', 'Contact'],
      scrollBar:            false,
      navigation:           false,
      verticalAlign:        false,
      arrowNavigation:      true,
      recordHistory:        false,

    };
    
    
 
    return (
      
      <div>
     
          
        
        <Sidebar/>
        
        <DarkModeToggle />
        
        <SectionsContainer className="container" {...options}>
          <Section class="section"  data-percentage="80" data-centered="true" > <Home /> </Section>
          <Section>  <About/> </Section> 
          <Section>  <Education/> </Section>
          <Section>  <Works/> </Section>          
          <Section>  <Contact/> </Section>     
        </SectionsContainer>
        
      </div>
    );
}}


 


